import React from 'react'
import { Switch } from '@mui/material'
import { useSetActivePublicityBannerMutation } from 'features'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

//TODO migrate to use hook

/**
 * Display the student's assets and button to define or change them in a grid cell
 * @param {object} params - The param object from the Mui DataGrid column definition
 * @returns {ReactComponentElement} - component with ammount format and button to toggle set assets dialog
 */
const GridBannerActiveStatus = ({ publicityurlid, able }) => {
  const [setActive, { isLoading }] = useSetActivePublicityBannerMutation()

  return (
    <div className="inline-flex flex-row gap-2 items-center">
      <Switch
        checked={able}
        onClick={
          !able
            ? (e) => {
                setActive({ id: publicityurlid })
              }
            : null
        }
      />
      {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
    </div>
  )
}

export const MemoizedGridBannerActiveStatus = React.memo(GridBannerActiveStatus)

export default GridBannerActiveStatus
